<div class="overflow-y-auto height-without-bar lg:h-full">
  <div class="w-full h-full flex justify-center items-center">
    <div class="spinner-border custom-big-spinner border-white" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>
</div>
